import { useTheme } from '@emotion/react';
import React from 'react';

import { Alert, Box, Collapse, Icon } from '~/components/blocks';

export const PrescriptionCollapseFallback = React.memo(() => {
  const theme = useTheme();

  return (
    <Collapse
      label={
        <>
          <Icon size="xxl" icon="drug" />
          処方箋
        </>
      }
    >
      <Box padding={theme.space.m}>
        <Alert status="info">患者の持参した処方箋をご確認ください</Alert>
      </Box>
    </Collapse>
  );
});

PrescriptionCollapseFallback.displayName = 'PrescriptionCollapseFallback';
